module.exports = __webpack_public_path__ + "img/infoAuthing.1ed572b7.png";